<template>
  <div class="page-communication">
    <landing-header />

    <main>
      <section class="hero-comm">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-comm">Relation Client 2.0</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Communiquez <br />
              <span class="gradient-text">sans y penser</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              SMS de rappel, confirmations par email, demandes d'avis Google... Termoflow gère vos échanges clients automatiquement pour que vous restiez concentrés sur vos chantiers.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="sms-preview shadow-2xl">
              <div class="sms-bubble client">Bonjour, à quelle heure passe le technicien ?</div>
              <div class="sms-bubble auto">
                <div class="auto-tag">Automatique</div>
                Bonjour ! Thomas passera demain entre 14h et 16h pour votre entretien PAC.
              </div>
              <div class="sms-bubble auto rating">
                <i class="fa-solid fa-star text-yellow-400"></i>
                L'intervention est terminée ! Donnez-nous votre avis ici...
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white border-t border-gray-100">
        <div class="max-w-7xl mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div class="comm-card">
              <div class="comm-icon blue"><i class="fa-solid fa-bell"></i></div>
              <h3 class="text-xl font-bold mb-4">Zéro absence</h3>
              <p class="text-gray-600">SMS et emails de rappel automatisés avant chaque intervention. Réduisez drastiquement les portes closes et les déplacements inutiles.</p>
            </div>
            <div class="comm-card">
              <div class="comm-icon green"><i class="fa-solid fa-paper-plane"></i></div>
              <h3 class="text-xl font-bold mb-4">Suivi Post-Visite</h3>
              <p class="text-gray-600">Envoi immédiat des rapports d'intervention et des documents dès que le technicien valide sa mission sur le terrain.</p>
            </div>
            <div class="comm-card">
              <div class="comm-icon orange"><i class="fa-solid fa-ranking-star"></i></div>
              <h3 class="text-xl font-bold mb-4">Réputation Booster</h3>
              <p class="text-gray-600">Sollicitez automatiquement vos clients satisfaits pour obtenir des avis Google et renforcer votre visibilité locale.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row items-center gap-20">
            <div class="lg:w-1/2">
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Le rappel d'entretien : <br/>Votre allié fidélité</h2>
              <p class="text-gray-600 mb-8 text-lg">Ne laissez plus vos contrats d'entretien dormir. Termoflow détecte les échéances et relance vos clients automatiquement pour fixer le prochain rendez-vous.</p>
              <div class="feature-item-pro">
                <i class="fa-solid fa-check-circle"></i>
                <span>Messages 100% personnalisables à votre image</span>
              </div>
              <div class="feature-item-pro">
                <i class="fa-solid fa-check-circle"></i>
                <span>Déclenchement basé sur les données réelles du terrain</span>
              </div>
              <div class="feature-item-pro">
                <i class="fa-solid fa-check-circle"></i>
                <span>Historique complet des échanges par fiche client</span>
              </div>
            </div>
            <div class="lg:w-1/2">
              <div class="automation-flow shadow-xl">
                <div class="flow-step">Fin d'intervention <i class="fa-solid fa-chevron-right"></i></div>
                <div class="flow-step">Envoi Rapport <i class="fa-solid fa-chevron-right"></i></div>
                <div class="flow-step highlight">Demande Avis Google</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div class="stat-comm-box">
              <span class="stat-number">-40%</span>
              <p class="stat-label">de "Portes Closes"</p>
            </div>
            <div class="stat-comm-box">
              <span class="stat-number">2h</span>
              <p class="stat-label">gagnées / jour / admin</p>
            </div>
            <div class="stat-comm-box">
              <span class="stat-number">x3</span>
              <p class="stat-label">d'avis Google positifs</p>
            </div>
            <div class="stat-comm-box">
              <span class="stat-number">100%</span>
              <p class="stat-label">de clients informés</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-8">Professionnalisez vos échanges dès aujourd'hui</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'CommunicationAutomatedPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-comm {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fff7ed, transparent 35%);
}

.badge-comm {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #fff7ed;
  color: #c2410c;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

/* --- SMS PREVIEW --- */
.sms-preview {
  background: #e5e7eb;
  padding: 2rem;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.sms-bubble {
  max-width: 80%;
  padding: 1rem;
  border-radius: 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  position: relative;
}
.sms-bubble.client { background: white; align-self: flex-start; border-bottom-left-radius: 0; color: #374151; }
.sms-bubble.auto { background: #3b82f6; color: white; align-self: flex-end; border-bottom-right-radius: 0; }
.sms-bubble.rating { background: #1f2937; color: white; align-self: flex-end; border-bottom-right-radius: 0; border: 2px solid #f97316; }

.auto-tag {
  font-size: 0.6rem;
  text-transform: uppercase;
  background: rgba(255,255,255,0.2);
  padding: 0.1rem 0.4rem;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  display: inline-block;
}

/* --- CARDS --- */
.comm-card { padding: 1rem; text-align: center; }
.comm-icon { width: 4rem; height: 4rem; border-radius: 1.2rem; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; margin: 0 auto 1.5rem; }
.comm-icon.blue { background: #eff6ff; color: #3b82f6; }
.comm-icon.green { background: #f0fdf4; color: #22c55e; }
.comm-icon.orange { background: #fff7ed; color: #f97316; }

/* --- FEATURES --- */
.feature-item-pro { display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; font-weight: 700; color: #4b5563; }
.feature-item-pro i { color: #22c55e; }

.automation-flow {
  background: white;
  padding: 3rem;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.flow-step {
  padding: 1rem;
  background: #f9fafb;
  border-radius: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 800;
  color: #9ca3af;
}
.flow-step.highlight { border: 2px solid #f97316; color: #f97316; background: #fff7ed; }

/* --- STATS --- */
.stat-comm-box { text-align: center; padding: 2rem; background: #f9fafb; border-radius: 1.5rem; }
.stat-number { display: block; font-size: 2.5rem; font-weight: 900; color: #1f2937; margin-bottom: 0.5rem; }
.stat-label { font-weight: 700; color: #6b7280; font-size: 0.9rem; }

/* --- BUTTONS --- */
.btn-primary { background: linear-gradient(to right, #f97316, #ef4444); color: white; padding: 1rem 2.5rem; border-radius: 9999px; font-weight: 700; border: none; }
.btn-primary-large { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-comm { text-align: center; padding-top: 8rem; }
  .hero-comm .flex { flex-direction: column; }
  .sms-preview { margin-top: 4rem; }
}
</style>